import api from './client'; // Import the same shared client


export const sendLoginCode = async (email) => {
  const response = await api.post('/api/auth/send-code', { email });
  return response.data;
};

export const verifyLoginCode = async (email, code) => {
  const response = await api.post('/api/auth/verify-code', { email, code });
  return response.data;
};